
  (function () {
    function equalizeCardHeights() {
      var cards = document.querySelectorAll('#vocGlide .voc-card-inner');
      if (!cards.length) return;

      // Reset heights first
      cards.forEach(function(card) {
        card.style.height = 'auto';
        card.style.minHeight = 'auto';
      });

      // Find the tallest card
      var maxH = 0;
      cards.forEach(function(card) {
        if (card.offsetHeight > maxH) maxH = card.offsetHeight;
      });

      // Apply same height to all cards
      if (maxH > 0) {
        cards.forEach(function(card) {
          card.style.height = maxH + 'px';
        });
      }
    }

    function initGlide() {
      if (typeof Glide === 'undefined') {
        setTimeout(initGlide, 100);
        return;
      }

      var el = document.getElementById('vocGlide');
      if (!el) return;

      var glide = new Glide('#vocGlide', {
        type: 'carousel',
        startAt: 1,
        perView: 3.6,
        gap: 10,
        autoplay: 4000,
        hoverpause: true,
        animationDuration: 600,
        breakpoints: {
          900: { perView: 1.4 },
          600: { perView: 1.2 }
        }
      });

      // Wait 100ms after mount so Glide fully renders all slides
      glide.on('mount.after', function() {
        setTimeout(equalizeCardHeights, 100);
      });

      glide.mount();

      // Re-equalize on window resize
      window.addEventListener('resize', function() {
        setTimeout(equalizeCardHeights, 150);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGlide);
    } else {
      initGlide();
    }

  })();
